export const appointmentStatusStyle = (status) => ({
  cancelled: 'calendar-index__item--grey',
  opened: 'calendar-index__item--grey',
  booked: 'calendar-index__item--booked',
  confirmed: 'calendar-index__item--confirmed'
}[status]);



// WEBPACK FOOTER //
// ./app/lib/calendarSharedMethods.js